function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M57.0352,106.9723c-27.2389-.1365-49.7258-22.9257-49.62-50.2875C7.5206,29.2011,30.392,6.7442,58.0374,6.98c27.2011.2318,49.5709,23.13,49.37,50.5361C107.2083,84.7654,84.45,107.11,57.0352,106.9723Zm1.26-6.3052c24.5245-2.1883,42.1376-18.4713,42.409-42.8539.2918-26.21-18.07-44.468-44.1722-44.129-24.548.3189-42.144,18.0756-42.4144,42.4538C13.8273,82.3481,32.17,99.2269,58.2957,100.6671Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.507,88.006C45.2663,88.0238,36.1406,80.88,32.9517,68.7c-.5393-2.06-1.3533-4.5527,1.647-5.3756,2.8762-.7889,4.242,1.0108,4.8407,3.6475C42.7407,81.51,58.8855,85.2976,68.8424,77.3294a17.3739,17.3739,0,0,0,6.43-10.3624c.5617-2.802,1.9021-4.32,4.7419-3.703,3.0981.6732,2.431,3.1327,1.92,5.2272C78.997,80.5371,69.6323,87.9883,57.507,88.006Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.9461,47.768c-3.1059-.7254-5.6162-2.2527-6.2586-5.5442-.4737-2.4265,3.4849-6.2007,6.2417-5.9076,3.2614.3466,5.8043,2.2557,5.8277,5.6514C47.7806,45.3981,45.1138,47.0106,41.9461,47.768Z",
  fill: "currentColor"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.014,42.0955c-.8622,3.2718-2.8607,5.6246-6.2026,5.4791-3.2309-.14-5.8384-2.2978-5.7087-5.7436a5.55,5.55,0,0,1,6.0012-5.4486C76.3989,36.4675,78.39,38.7884,79.014,42.0955Z",
  fill: "currentColor"
}));

var SvgEmoticonGood = function SvgEmoticonGood(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 113.3858 113.3858",
    width: 40,
    height: 40,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmoticonGood, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emoticon_good.8de2cd7b.svg";
export { ForwardRef as ReactComponent };